import { useUser } from 'contexts/userContext';
import { useNavigate } from 'react-router-dom';
import checkIsRegistered from 'utils/checkIsRegistered';
import { getB2BLanding } from 'utils/redirectByUserType';
import { isUserAdmin, isUserGuide } from 'utils/isRole';
import { MENTOR_ROUTES, TRAVELLER_ROUTES, AUTH_ROUTES } from 'constants/routes';

const useNavbar = () => {
  const { userRole, whoAmI, user } = useUser();
  const navigate = useNavigate();
  const hasUser = Object.keys(whoAmI).length > 0;
  const isRegistered = checkIsRegistered({ whoAmI });

  const handleBeTravelAdvisor = () => {
    navigate(AUTH_ROUTES.GUIDE_REGISTER);
  };

  function checkURLRedirect() {
    const b2bLanding = getB2BLanding(user) || getB2BLanding(whoAmI);
    if (b2bLanding) return b2bLanding;

    if (hasUser && isRegistered) {
      return isUserGuide(userRole) || isUserAdmin(userRole)
        ? MENTOR_ROUTES.HOME
        : TRAVELLER_ROUTES.HOME;
    } else if (hasUser && !isRegistered) {
      return AUTH_ROUTES.REGISTER;
    } else {
      return '/';
    }
  }

  return {
    checkURLRedirect,
    handleBeTravelAdvisor,
  };
};

export default useNavbar;
